module.exports = __webpack_public_path__ + "img/2025-04-12a_2.7605da7c.jpg";